var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header',{staticClass:"flex justify-center p-2 header"},[_c('img',{attrs:{"src":require("@/assets/Svg/logo.svg"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }